import { useNavigate, useParams } from "react-router-dom";
import { clientRoutes } from "@/lib/clientRoutes";
import { useClientTab } from "@/hooks/useClients";
import type { ClientLegalEntity } from "@/api/clients";
import { ContractDetailV2 } from "@/pages/contracts/ContractDetailV2";
import { CreateContractDrawer } from "@/components/contract/CreateContractDrawer";

/**
 * Contract UNIFICATION — Client360 contract context reuses the SAME components as
 * the standalone /contracts surface (no separate A4/F4B placeholder):
 *   /clients/:holdingId/contracts/:contractId → ContractDetailV2 (the one detail)
 *   /clients/:holdingId/contracts/new         → CreateContractDrawer (one create)
 * The new draft lands in ContractDetailV2 within the same holding context, where
 * commercial terms are editable (crm_managed draft). Mirrors the list-row link.
 */
export function ContractDrawerShell() {
  const { holdingId, contractId } = useParams<{ holdingId: string; contractId: string }>();
  const navigate = useNavigate();
  const isNew = !contractId || contractId === "new";

  // BUG2 — «Новий договір» з картки клієнта: prefill «Клієнт» поточним клієнтом
  // з контексту роуту (primary / перша доступна юрособа холдингу). Поле лишається
  // змінюваним (entryPoint="list") — для multi-LE менеджер може обрати іншу LE.
  const leQ = useClientTab<ClientLegalEntity>(holdingId, "legal-entities", isNew);
  const leItems = leQ.data?.items ?? [];
  const viewable = leItems.filter((m) => m.canView !== false);
  const prefillLe = viewable.find((m) => m.isPrimary) ?? viewable[0] ?? leItems[0] ?? null;
  const prefillAccount = prefillLe ? { id: prefillLe.id, name: prefillLe.name } : null;

  if (isNew) {
    return (
      <CreateContractDrawer
        open
        entryPoint="list"
        account={prefillAccount}
        onClose={() => navigate(clientRoutes.contracts(holdingId ?? ""))}
        onCreated={(cid) => navigate(clientRoutes.contract(holdingId ?? "", cid))}
      />
    );
  }

  return (
    <ContractDetailV2
      contractId={contractId}
      backTo={clientRoutes.contracts(holdingId ?? "")}
    />
  );
}
